import { z } from 'zod'

import { RoleType, UserStatus } from '@/modules/graphql/codegen/graphql'

export const usersSearchSchema = z.object({
  page: z.number().int().positive().catch(1),
  search: z.string().optional().catch(undefined),
  status: z.nativeEnum(UserStatus).optional().catch(undefined),
  roleType: z.nativeEnum(RoleType).optional().catch(undefined),
  roleId: z.string().optional().catch(undefined),
})
